import { Model } from './model';

export class Specie extends Model {
  id: number;
  name: string;
  fao_code: string;
  _label: string;

  constructor(values: Object = {}) {
    super(values);
    this._label = `${this.name} [${this.fao_code}]`;
  }

  apiMap(values: Object = {}) {
    return new Specie(values);
  }
}



// WEBPACK FOOTER //
// ./src/app/_models/specie.ts